import { action, makeObservable, observable } from 'mobx';
import { optInTracking, optOutTracking } from 'utils/analytics/analytics';

import { RootStore } from './RootStore';

const COOKIE_CONSENT_STORE_KEY_FOR_WINDOW_OBJECT = 'daymadeCookieConsentStore';

/** The cookie consent store. Note that this store gets its values initialised when the CookieConsentPopup
 * component is rendered as part of the DOM.
 */
export class CookieConsentStore {
  root: RootStore;
  marketingCookiesConsent: boolean = false;
  analyticsCookiesConsent: boolean = false;

  constructor(root: RootStore) {
    this.root = root;

    makeObservable(this, {
      marketingCookiesConsent: observable,
      analyticsCookiesConsent: observable,
      setAnalyticsCookiesConsent: action,
      setMarketingCookiesConsent: action,
    });

    if (typeof window === 'object') {
      if ((window as any)[COOKIE_CONSENT_STORE_KEY_FOR_WINDOW_OBJECT]) {
        console.warn(
          'A Cookie Consent store was already registered. The old instance will be overwritten.',
        );
      }
      (window as any)[COOKIE_CONSENT_STORE_KEY_FOR_WINDOW_OBJECT] = this;
    }
  }

  setMarketingCookiesConsent = (consent: boolean) => {
    this.marketingCookiesConsent = consent;
  };

  setAnalyticsCookiesConsent = (consent: boolean) => {
    this.analyticsCookiesConsent = consent;

    if (typeof window === undefined) return;

    if (!consent && !this.root.userStore.currentUser) {
      optOutTracking();
    } else {
      optInTracking();
    }
  };
}

export function getGlobalCookieConsentStore() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const cookieConsentStore: undefined | CookieConsentStore = (window as any)[
    COOKIE_CONSENT_STORE_KEY_FOR_WINDOW_OBJECT
  ];
  return cookieConsentStore;
}
